<template>
  <modal
    v-if="sensorList.length > 0"
    name="sensor-modal"
    height="50%"
    :clickToClose="false"
    :adaptive="true"
    @before-close="beforeClose"
    class="test"
  >
    <div
      class="absolute top-2 left-0 right-0 mx-4 mt-4 flex justify-center"
      style="top: 0; bottom: 0"
    >
      <div class="mt-1 mb-10">
        <div>
          <div class="text-center text-black text-sm mx-2 text-2xl">
            {{ $t("alarm_modal_title") }}
          </div>
          <form class="mt-4 sm:mt-10 mx-2" style="max-width: 290px">
            <div class="md:flex md:items-center mb-0 sm:mb-4">
              <div class="md:w-1/2">
                <label
                  class="
                    block
                    text-gray-500
                    font-bold
                    md:text-start
                    mb-1
                    md:mb-0
                    pr-4
                  "
                  for="sensor"
                >
                  {{ $t("alarm_modal_sensor") }}
                </label>
              </div>
              <div class="md:w-1/2">
                <select
                  name="sensor"
                  id="sensor"
                  @change="onChangeSensor($event)"
                  v-model="sensor.sensor"
                  class="
                    w-full
                    md:block
                    text-gray-500
                    font-bold
                    mb-1
                    md:mb-0
                    pr-4
                    border border-black-500
                  "
                >
                  <option
                    v-for="(item, index) in sensorList"
                    :key="index"
                    :value="item"
                  >
                    {{ item.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="md:flex md:items-center mb-1 sm:mb-6">
              <div class="md:w-1/2">
                <label
                  class="
                    block
                    text-gray-500
                    font-bold
                    md:text-start
                    mb-1
                    md:mb-0
                    pr-4
                  "
                  for="inline-full-name"
                >
                  {{ $t("alarm_modal_notification") }}
                </label>
              </div>
              <div class="md:w-1/2">
                <select
                  name=""
                  v-model="sensor.notification"
                  class="
                    w-full
                    md:block
                    text-gray-500
                    font-bold
                    mb-1
                    md:mb-0
                    border border-black-500
                  "
                >
                  <option value="email">email</option>
                  <option value="telegram">telegram</option>
                </select>
              </div>
            </div>

            <div
              class="text-red-500 text-center pb-4"
              v-if="sensor.notification === 'telegram'"
            >
              <a :href="$t('profile_link')" target="_blank">{{
                $t("instructions_telegram")
              }}</a>
            </div>
            <div
              class="text-red-500 text-center pb-4 w-full"
              v-if="sensor.notification === 'email'"
            >
              <div>{{ $t("instructions_email") }}</div>
            </div>
          </form>

          <div class="text-red-400 text-center mt-10">{{ error }}</div>
        </div>
      </div>
      <div
        class="md:flex md:items-center"
        style="position: absolute; right: 20px; bottom: 20px"
      >
        <div class="ml-auto">
          <button
            class="
              shadow
              focus:shadow-outline
              focus:outline-none
              font-bold
              py-1
              sm:py-2
              px-4
              rounded
            "
            style="background: #fbb03b; color: #fff"
            type="button"
            @click="$modal.hide('sensor-modal'), resetSensor()"
          >
            {{ $t("modal_button_cancel") }}
          </button>
          <button
            :disabled="
              sensor.sensor && sensor.notification
                ? !disabledButton
                : disabledButton
            "
            class="
              shadow
              focus:shadow-outline
              focus:outline-none
              text-white
              font-bold
              py-1
              sm:py-2
              px-4
              ml-4
              rounded
            "
            :style="
              sensor.sensor && sensor.notification
                ? 'background: #fbb03b; color: #fff;'
                : 'background: #5c5b5b; color: #fff;'
            "
            type="button"
            @click="addSensor()"
          >
            {{ $t("modal_button_add") }}
          </button>
        </div>
      </div>
    </div>
  </modal>
</template>
<script>
/**
 * Componente modal creacion de alarmas
 * --------------------------------------------
 *
 * Este componente se abre al darle al botón añadir en la vista de alarmas.
 * Cuando quieres crear una nueva alarma, se abre el modal y muestra un desplegable para seleccionar el sensor y otro para elegir el tipo de notificación.
 *
 */
import { addAlarm } from "@/utils/AlarmService.js";
import { mapState } from "vuex";

export default {
  props: ["sensors", "nightMode", "selectedHub"],
  data() {
    return {
      sensor: {},
      error: "",
      sensorList: [],
      sensorSelected: {},
      disabledButton: true,
    };
  },
    /**
    * Hace la primera carga de sensores del solarhub del cluster seleccionado.
    */
  beforeMount() {
    this.loadingSensors();
  },
  methods: {
    /**
    * Cada vez que se selecciona un sensor del desplegable, actualiza el sensor seleccionado.
    */
    onChangeSensor(event) {
      this.sensorSelected = event.target.value;
    },
    /**
    * Antes de cerrar al darle a aceptar, intenta crear la alarma con los datos seleccionados( el sensor y la notificación)
    * si todo sale bien limpia el obtjeto sensor creado, cierra el modal y emite una señal de creación.
    */
    beforeClose(event) {},
    async addSensor() {
        const data = await addAlarm(
          this.sensor,
          this.currentCluster[0].id,
          this.currentCluster[0].solarHubs[this.selectedHub].id
        );
        if (data) {
          this.$emit("addAlarmToTable", this.sensor);
          this.resetSensor();
          this.$modal.hide("sensor-modal");
        }
    
    },
    /**
    * Carla la lista de sensores del solarhub seleccionado, filtrando unos que no se deben mostrar.
    */
    async loadingSensors() {
      let sensorListData =
        this.currentCluster[0].solarHubs[this.selectedHub].sensors;
      this.sensorList = sensorListData.filter(
        (s) =>
          s.influxId == "NO2" ||
          s.influxId == "SO2" ||
          s.influxId == "CO" ||
          s.influxId == "PM10" ||
          s.influxId == "PM2_5" ||
          s.influxId == "O3"
      );
    },
    /**
    * reinicía el objeto sensor para que al abrir de nuevo el modal no esté rellenado automáticamente.
    */
    resetSensor() {
      this.sensor = {};
    },
  },
  computed: {
    ...mapState("clusters", ["currentCluster"]),
  },
  watch: {
    /**
    * Cada vez que se cambia de cluster o de solarhub se actualiza la lista de sensores a mostrar.
    */
    currentCluster: function () {
      this.loadingSensors();
    },
    selectedHub: function () {
      this.loadingSensors();
    },
  },
};
</script>
<style scoped>
.vm--modal {
  border: 2px solid #fff;
  border-radius: 10px;
  height: 50% !important;
}
.dark-modal {
  background: #ffffff;
  color: #121212;
}
.light-modal {
  background-color: #121212;
  color: #fff;
}
</style>